import api from "../helpers/api";

class CategoryService{

    async get_categories(page=1) {
        
        return await api.get(`/categories?page=${page}`,
            { headers: { "Content-Type": "application/json" } }
        )

        .then((response) => {
            return response;
        });
    }
    async get_category(id) {
        
        return await api.get(`/categories/${id}`,
            { headers: { "Content-Type": "application/json" } }
        )

        .then((response) => {
            return response;
        });
    }
    async create_subcategory(id,data) {
        if(id){
            console.log(id);
            
        }
        return await api.post(`/sub-categories`,
           data,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response;
        });
    }
    async fetch_subcategory(id) {
        
        return await api.get(`/sub-categories/${id}`,
            { headers: { "Content-Type": "application/json" } }
        )

        .then((response) => {
            return response.data;
        });
    }
    async fetch_subcategories(page) {
        
        return await api.get(`/sub-categories?page=${page}`,
            { headers: { "Content-Type": "application/json" } }
        )

        .then((response) => {
            return response;
        });
    }
    async updateSubcategory(id,payload) {
        
        return await api.put(`/sub-categories/${id}`,
           payload,
            { headers: { "Content-Type": "application/json" } }
        )
        .then((response) => {
            return response;
        });
    }



    
   
}
export default new CategoryService;